//components
import { Button as BaseButton } from '@mui/material';

//css
import styled from 'styled-components';

const rubricOptions = {
  CreateRubric: 'Crear Rubric',
};

const Options = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 2%;
  margin-bottom: 2%;
`;

const Button = styled(BaseButton)`
  &&& {
    margin-right: 2%;
  }
`;

export const GenerateRubricOptions = props => {
  const { handleClick } = props;
  return (
    <Options>
      {Object.keys(rubricOptions).map(item => {
        return (
          <Button key={item} id={item} variant='contained' onClick={handleClick}>
            {rubricOptions[item]}
          </Button>
        );
      })}
    </Options>
  );
};
